import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import styles from './ConTrend.module.css';
import { Button, Card, Col, Input, Modal, notification, Row, Space, Spin, Table, Tag, Tooltip, Typography } from 'antd';
import { CloudDownloadOutlined, SearchOutlined, SubnodeOutlined, ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';
const { Text } = Typography;

const renderActsDoms = (value, row, index) => {
    return <>{Array.isArray(value) ? value.join(', ') : value}</>;
};

const openNotificationWithIcon = (type, msg) => {
    notification[type]({
        message: msg,
        duration: 1.5,
    });
};

export const OpenModal = (props) => {
    const [show, setShow] = useState(false);
    const [modData, setModData] = useState('');
    const [load, setLoad] = useState(true);
    const openModal = () => setShow(true);
    const closeModal = () => {
        setSearchVal('');
        setShow(false);
        setTrig(true);
        props.setEvent(false);
        setDetData(true);
    };
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);
    const [trig, setTrig] = useState(true);
    const [app, setApp] = useState('');
    const [detData, setDetData] = useState(true);

    const rel = parseInt(props.relAct.substr(2, 4));
    const prevRel = rel - 1;
    const curRel = parseInt(props.curRelVer.substr(2, 4));
    const diff = curRel - rel;

    const iniCol = [
        {
            title: 'App Name',
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            responsive: ['sm'],
            width: '20%',
            render: (value, row, index) => {
                let color = '';

                if (row.action.toLowerCase() === 'modified') {
                    color = '#ffffb8';
                } else if (row.action.toLowerCase() === 'added') {
                    color = '#d9f7be';
                } else if (row.action.toLowerCase() === 'removed') {
                    color = '#ffd8bf';
                }
                return (
                    <div style={{ backgroundColor: color }}>
                        {diff <= 1 ? (
                            <a
                                onClick={() => {
                                    setApp(row.current_name);
                                    // setOpenModal(true);
                                    setTrig(!trig);
                                    // openModal();
                                }}
                            >
                                {value}
                            </a>
                        ) : (
                            value
                        )}
                    </div>
                );
            },
        },
        // {
        //   title: "action",
        //   dataIndex: "action",
        //   key: "action",
        //   fixed: "left",
        //   responsive: ["sm"],
        //   width: "20%",
        //   render: renderContent,
        // },
    ];

    const latCol = [
        {
            title: 'App Name',
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            responsive: ['sm'],
            width: '17%',
            render: (value, record, index) => {
                let color = '';

                if (record.action.toLowerCase() === 'modified') {
                    color = '#ffffb8';
                } else if (record.action.toLowerCase() === 'added') {
                    color = '#d9f7be';
                } else if (record.action.toLowerCase() === 'removed') {
                    color = '#ffd8bf';
                }
                return (
                    <div style={{ backgroundColor: color }}>
                        {record.action !== 'REMOVED' ? (
                            <a
                                onClick={() => {
                                    setApp(record.current_name);
                                    // setOpenModal(true);
                                    setTrig(!trig);
                                    // openModal();
                                }}
                            >
                                {value}
                            </a>
                        ) : (
                            value
                        )}
                    </div>
                );
            },
        },
        // {
        //   title: "action",
        //   dataIndex: "action",
        //   key: "action",
        //   fixed: "left",
        //   responsive: ["sm"],
        //   width: "2%",
        //   render: renderContent,
        // },
        {
            title: 'activity Added',
            dataIndex: 'actAdded',
            key: 'actAdded',
            fixed: 'left',
            responsive: ['sm'],
            width: '18%',
            render: renderActsDoms,
        },
        {
            title: 'activity Removed',
            dataIndex: 'actRemoved',
            key: 'actRemoved',
            fixed: 'left',
            responsive: ['sm'],
            width: '18%',
            render: renderActsDoms,
        },
        {
            title: 'Domain Added',
            dataIndex: 'domAdded',
            key: 'domAdded',
            fixed: 'left',
            responsive: ['sm'],
            width: '24%',
            render: renderActsDoms,
        },
        {
            title: 'Domain Removed',
            dataIndex: 'domRemoved',
            key: 'domRemoved',
            fixed: 'left',
            responsive: ['sm'],
            width: '24%',
            render: renderActsDoms,
        },
    ];

    const fetchDetData = async () => {
        try {
            setLoad(true);
            setDetData(false);
            const start = Date.now();

            if (diff <= 1) {
                const modData = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetActDom',
                    firstVal: 'snapshot_v' + rel + '_0_0',
                    secondVal: 'R-' + rel,
                });

                const newArray = modData['data']
                    ? modData['data'].map((obj, i) => ({
                          ...obj,
                          ind: i,
                          release_name: 'R-' + rel,
                          actAdded: obj.actAdded.split(','),
                          actRemoved: obj.actRemoved.split(','),
                          domAdded: obj.domAdded.split(','),
                          domRemoved: obj.domRemoved.split(','),
                      }))
                    : modData['data'];

                const milli = Date.now() - start;
                // console.log(newArray);

                setOrigData(newArray);
                setFilteredData(newArray);
                const searchInd = newArray.map((user) => {
                    const allValues = crawl(user);
                    return { allValues: allValues.toString() };
                });
                setSearchIndex(searchInd);
                return { success: 1, data: newArray };
            }
        } catch (error) {
            console.error(error);
            return '';
        } finally {
            setLoad(false);
        }
    };

    const fetchDwnData = async () => {
        try {
            setLoad(true);
            const start = Date.now();
            // console.log(props.modData["data"]);
            setModData(props.modData['data']);
            return props.modData;
        } catch (error) {
            console.error(error);
            return '';
        } finally {
            setLoad(false);
            openNotificationWithIcon('success', 'Added Apps displayed in green');
            setTimeout(function () {
                openNotificationWithIcon('warning', 'Modified Apps displayed in yellow');
            }, 700);
            setTimeout(function () {
                openNotificationWithIcon('error', 'Removed Apps displayed in red');
            }, 1400);
        }
    };

    useEffect(() => {
        setLoading(true);
        const fetchDatas = async () => {
            const { data: users } = await fetchDwnData();
            setOrigData(users);
            setFilteredData(users);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
            if (users) setLoading(false);
        };
        if (props.openModal === true) {
            fetchDatas();
        }
    }, [props.openModal]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.openModal]);

    // initial effect
    useEffect(() => {
        if (props.openModal === true) {
            openModal();
            // fetchDwnData(props.relAct);
        }
    }, [props.openModal]);

    return (
        <>
            <Modal
                title={
                    trig ? (
                        <>
                            <Row>
                                <Col className="gutter-row" span={20}>
                                    <Space>
                                        <Text className={styles.padder}>Release {props.relAct}</Text>
                                        {diff <= 1 ? (
                                            <Button
                                                type="primary"
                                                icon={<SubnodeOutlined />}
                                                shape="round"
                                                onClick={detData ? fetchDetData : null}
                                                // style={{ backgroundColor: "#f0f5ff" }}
                                                size="small"
                                            >
                                                Detailed Report
                                            </Button>
                                        ) : null}
                                    </Space>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <Row gutter={16}>
                            <Col className="gutter-row" span={2}>
                                <ArrowLeftOutlined
                                    onClick={() => {
                                        setTrig(!trig);
                                    }}
                                />
                            </Col>
                            {/* <Col className="gutter-row" span={1}></Col> */}
                            <Col className="gutter-row" span={20}>
                                <Text keyboard>
                                    <>{app}</>
                                </Text>
                            </Col>

                            <Col className="gutter-row" span={1}>
                                <Space size="small" align="end">
                                    <Tooltip
                                        placement="bottom"
                                        title={
                                            <div
                                                style={{
                                                    fontSize: '9px',
                                                    fontFamily: 'Gill, Helvetica, sans-serif',
                                                }}
                                            >
                                                <ul>
                                                    <li>
                                                        <p>
                                                            <Text>No Change</Text>: indicates same as previous release
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            <Text delete type="danger">
                                                                Red Text
                                                            </Text>
                                                            : indicates removed in this release
                                                        </p>
                                                        {/* <span style={{ color: "red" }}>Red text</span> */}
                                                    </li>
                                                    <li>
                                                        <p>
                                                            <Text type="success">Green Text</Text>: indicates added in this release
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        }
                                        color="#425162"
                                        // style={{ width: "700px" }}
                                    >
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                </Space>
                            </Col>
                            <Col className="gutter-row" span={1}></Col>
                        </Row>
                    )
                }
                visible={show}
                onOk={closeModal}
                confirmLoading={load}
                style={{ top: 20 }}
                onCancel={closeModal}
                width={!detData || !trig ? '55%' : '25%'}
            >
                {trig ? (
                    <Card
                        title={load ? <div>{<Spin size="small" />}</div> : <Tag color={'cyan'}>App Connectors: {filteredData.length}</Tag>}
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        // style={{ height: 470, margin: "1px", padding: "1px" }}
                        extra={
                            <Row>
                                <Col span={21}>
                                    <Input
                                        value={searchVal}
                                        onChange={(e) => {
                                            setSearchVal(e.target.value);
                                        }}
                                        prefix={<SearchOutlined className="site-form-item-icon" />}
                                        placeholder="Crawl Search"
                                        allowClear
                                    />
                                </Col>
                                <Col span={1}></Col>
                                <Col className="gutter-row" span={2}>
                                    {' '}
                                    <div>
                                        {load ? (
                                            <div>{<Spin size="small" />}</div>
                                        ) : (
                                            <Tooltip
                                                placement="topRight"
                                                title={detData ? 'Download modified Rel-' + rel : 'Download detailed modified Rel-' + rel}
                                                arrowPointAtCenter
                                            >
                                                <CSVLink
                                                    filename={detData ? 'modified_apps__rel-' + rel : 'detailed_modified_apps__rel-' + rel}
                                                    data={filteredData}
                                                    className="btn btn-primary"
                                                >
                                                    <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                                </CSVLink>
                                            </Tooltip>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        }
                    >
                        {load ? (
                            <div className={styles.spinner}>{<Spin size="small" />}</div>
                        ) : (
                            <Table
                                rowkey="id"
                                size="small"
                                bordered
                                scroll={{ x: 550, y: 900 }}
                                style={{ margin: '2px' }}
                                dataSource={filteredData}
                                loading={load}
                                columns={!detData ? latCol : iniCol}
                                pagination={{
                                    pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                    defaultPageSize: ['10'],
                                    showSizeChanger: true,
                                }}
                            />
                        )}
                    </Card>
                ) : (
                    <OpenMod dat={'dat'} app={app} curRel={curRel} />
                )}
            </Modal>
        </>
    );
};

export const OpenMod = (props) => {
    const [load, setLoad] = useState(true);
    // const [usrRel, setUsrRel] = useState(props.usrRel);
    // const [rel, setRel] = useState(props.rel);
    // const [modData, setModData] = useState({
    //   conActName: "conAct",
    //   conAct: "",
    //   conActDom: "",
    //   conAppPrior: "",
    // });
    const [showAct1, setShowAct1] = useState(false);
    const [showAct2, setShowAct2] = useState(false);
    const [showDom1, setShowDom1] = useState(false);
    const [showDom2, setShowDom2] = useState(false);
    const rel = props.curRel;
    const prevRel = props.curRel - 1;
    const ppRel = props.curRel - 2;
    const [compData, setCompData] = useState([
        {
            release: '',
            actName: '',
            domain: '',
        },
    ]);
    const [compDomData, setCompDomData] = useState([]);
    const [compAddnData, setCompAddnData] = useState([
        {
            release: '',
        },
    ]);

    // Compare effect
    useEffect(() => {
        fetchCompData();
    }, [props.app]);

    const fetchCompData = async () => {
        try {
            setLoad(true);
            // setUsrRel(props.usrRel);
            const actData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppActs',
                preProcFunc: 'appActInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + ppRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + prevRel + '_0_0',
                seventhVal: 'snapshot_v' + prevRel + '_0_0',
                eigthVal: 'snapshot_v' + rel + '_0_0',
                ninthVal: 'snapshot_v' + rel + '_0_0',
                tenthVal: 'snapshot_v' + rel + '_0_0',
            });

            const domData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConDoms',
                preProcFunc: 'appDomInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + prevRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + rel + '_0_0',
                seventhVal: 'snapshot_v' + rel + '_0_0',
            });

            const addnData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppAddInfo',
                preProcFunc: 'appAddnInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + ppRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + prevRel + '_0_0',
                seventhVal: 'snapshot_v' + prevRel + '_0_0',
                eigthVal: 'snapshot_v' + rel + '_0_0',
                ninthVal: 'snapshot_v' + rel + '_0_0',
                tenthVal: 'snapshot_v' + rel + '_0_0',
            });
            actData['data'] && actData['data'].length > 0 ? setCompData(actData['data']) : setCompData('');
            domData['data'] && domData['data'].length > 0 ? setCompDomData(domData['data']) : setCompDomData('');
            addnData['data'] && addnData['data'].length > 0 ? setCompAddnData(addnData['data']) : setCompAddnData('');

            setLoad(false);
        } catch (error) {
            console.error(error);
            // actData["data"].length > 0 ? null : setCompData("");
            // setCompDomData("");
            // setCompAddnData("");
            setLoad(false);
        }
    };

    return (
        <>
            {!load ? (
                <>
                    <Card
                        className={styles.chart}
                        title={<Text keyboard> Activity </Text>}
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                        bordered={true}
                        loading={load}
                    >
                        {load ? (
                            <div>
                                <Spin size="small" />
                            </div>
                        ) : (
                            <>
                                <Table
                                    rowkey="appAct_id"
                                    size="small"
                                    bordered
                                    className="test"
                                    pagination={false}
                                    dataSource={compData}
                                    columns={[
                                        {
                                            title: () => {
                                                return <div style={{ fontSize: '12px' }}>Release </div>;
                                            },
                                            dataIndex: 'release',
                                            key: 'release',
                                            fixed: 'left',
                                            width: '10%',
                                            render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                        },
                                        {
                                            title: () => {
                                                return <div style={{ fontSize: '12px' }}>Activity </div>;
                                            },
                                            dataIndex: 'actName',
                                            key: 'actName',
                                            fixed: 'left',
                                            responsive: ['sm'],
                                            width: '90%',
                                            render: (text, row) => (
                                                <>
                                                    {row.id == 1 ? (
                                                        text ? (
                                                            <span style={{ fontSize: '11px' }}>{text.replaceAll(',', ', ')}</span>
                                                        ) : (
                                                            text
                                                        )
                                                    ) : row.id == 2 ? (
                                                        <div
                                                            onClick={() => {
                                                                setShowAct1(!showAct1);
                                                            }}
                                                            style={{ fontSize: '11px' }}
                                                        >
                                                            {!showAct1 ? (
                                                                row.actComp == 'No Change' ? (
                                                                    <a>{row.actComp}</a>
                                                                ) : row.actAdded.length != 0 && row.actRemoved.length != 0 ? (
                                                                    <>
                                                                        <Text type="success">
                                                                            {row.actAdded.toString().includes("'")
                                                                                ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                : row.actAdded.toString()}{' '}
                                                                        </Text>
                                                                        <Text delete type="danger">
                                                                            {row.actRemoved.toString().includes("'")
                                                                                ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                : row.actRemoved.toString()}
                                                                        </Text>
                                                                    </>
                                                                ) : row.actAdded.length != 0 ? (
                                                                    <Text type="success">
                                                                        {row.actAdded.toString().includes("'")
                                                                            ? row.actAdded.toString().replaceAll(',', ', ')
                                                                            : row.actAdded.toString()}{' '}
                                                                    </Text>
                                                                ) : (
                                                                    <Text delete type="danger">
                                                                        {row.actRemoved.toString().includes("'")
                                                                            ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                            : row.actRemoved.toString()}
                                                                    </Text>
                                                                )
                                                            ) : text ? (
                                                                text.replaceAll(',', ', ')
                                                            ) : (
                                                                text
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div
                                                            onClick={() => {
                                                                setShowAct2(!showAct2);
                                                            }}
                                                            style={{ fontSize: '11px' }}
                                                        >
                                                            {!showAct2 ? (
                                                                row.actComp == 'No Change' ? (
                                                                    <a>{row.actComp}</a>
                                                                ) : row.actAdded.length != 0 && row.actRemoved.length != 0 ? (
                                                                    <>
                                                                        <Text type="success">
                                                                            {row.actAdded.toString().includes("'")
                                                                                ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                : row.actAdded.toString()}{' '}
                                                                        </Text>
                                                                        <Text delete type="danger">
                                                                            {row.actRemoved.toString().includes("'")
                                                                                ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                : row.actRemoved.toString()}
                                                                        </Text>
                                                                    </>
                                                                ) : row.actAdded.length != 0 ? (
                                                                    <Text type="success">
                                                                        {row.actAdded.toString().includes("'")
                                                                            ? row.actAdded.toString().replaceAll(',', ', ')
                                                                            : row.actAdded.toString()}{' '}
                                                                    </Text>
                                                                ) : (
                                                                    <Text delete type="danger">
                                                                        {row.actRemoved.toString().includes("'")
                                                                            ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                            : row.actRemoved.toString()}
                                                                    </Text>
                                                                )
                                                            ) : text ? (
                                                                text.replaceAll(',', ', ')
                                                            ) : (
                                                                text
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            ),
                                        },
                                    ]}
                                    loading={load}
                                />
                            </>
                        )}
                    </Card>

                    <Card
                        className={styles.chart}
                        title={<Text keyboard> Domain </Text>}
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                        bordered={true}
                        loading={load}
                    >
                        {load ? (
                            <div>
                                <Spin size="small" />
                            </div>
                        ) : (
                            <>
                                <Table
                                    rowKey="appDom_id"
                                    size="small"
                                    bordered
                                    pagination={false}
                                    dataSource={compDomData}
                                    columns={[
                                        {
                                            title: () => {
                                                return <div style={{ fontSize: '12px' }}>Release </div>;
                                            },
                                            dataIndex: 'release',
                                            key: 'release',
                                            fixed: 'left',
                                            width: '10%',
                                            render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                        },
                                        {
                                            title: () => {
                                                return <div style={{ fontSize: '12px' }}>Domain </div>;
                                            },
                                            dataIndex: 'domName',
                                            key: 'domName',
                                            fixed: 'left',
                                            responsive: ['sm'],
                                            width: '90%',
                                            render: (text, row) => (
                                                <>
                                                    {row.id == 1 ? (
                                                        text ? (
                                                            <span style={{ fontSize: '11px' }}>{text.replaceAll(',', ', ')}</span>
                                                        ) : (
                                                            text
                                                        )
                                                    ) : row.id == 2 ? (
                                                        <div
                                                            onClick={() => {
                                                                setShowDom1(!showDom1);
                                                            }}
                                                            style={{ fontSize: '11px' }}
                                                        >
                                                            {!showDom1 ? (
                                                                row.domComp == 'No Change' ? (
                                                                    <a>{row.domComp}</a>
                                                                ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                    <>
                                                                        <Text type="success">
                                                                            {row.domAdded.toString().includes(',')
                                                                                ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                : row.domAdded.toString()}{' '}
                                                                        </Text>{' '}
                                                                        <Text delete type="danger">
                                                                            {row.domRemoved.toString().includes(',')
                                                                                ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                : row.domRemoved.toString()}{' '}
                                                                        </Text>
                                                                    </>
                                                                ) : row.domAdded.length != 0 ? (
                                                                    <Text type="success">
                                                                        {row.domAdded.toString().includes(',')
                                                                            ? row.domAdded.toString().replaceAll(',', ', ')
                                                                            : row.domAdded.toString()}{' '}
                                                                    </Text>
                                                                ) : (
                                                                    <Text delete type="danger">
                                                                        {row.domRemoved.toString().includes(',')
                                                                            ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                            : row.domRemoved.toString()}{' '}
                                                                    </Text>
                                                                )
                                                            ) : text ? (
                                                                text.replaceAll(',', ', ')
                                                            ) : (
                                                                text
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div
                                                            onClick={() => {
                                                                setShowDom2(!showDom2);
                                                            }}
                                                            style={{ fontSize: '11px' }}
                                                        >
                                                            {!showDom2 ? (
                                                                row.domComp == 'No Change' ? (
                                                                    <a>{row.domComp}</a>
                                                                ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                    <>
                                                                        <Text type="success">
                                                                            {row.domAdded.toString().includes(',')
                                                                                ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                : row.domAdded.toString()}{' '}
                                                                        </Text>{' '}
                                                                        <Text delete type="danger">
                                                                            {row.domRemoved.toString().includes(',')
                                                                                ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                : row.domRemoved.toString()}{' '}
                                                                        </Text>
                                                                    </>
                                                                ) : row.domAdded.length != 0 ? (
                                                                    <Text type="success">
                                                                        {row.domAdded.toString().includes(',')
                                                                            ? row.domAdded.toString().replaceAll(',', ', ')
                                                                            : row.domAdded.toString()}{' '}
                                                                    </Text>
                                                                ) : (
                                                                    <Text delete type="danger">
                                                                        {row.domRemoved.toString().includes(',')
                                                                            ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                            : row.domRemoved.toString()}{' '}
                                                                    </Text>
                                                                )
                                                            ) : text ? (
                                                                text.replaceAll(',', ', ')
                                                            ) : (
                                                                text
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            ),
                                        },
                                    ]}
                                    loading={load}
                                />
                            </>
                        )}
                    </Card>

                    {/* {Additional data} */}
                    {compAddnData ? (
                        <Card
                            className={styles.chart}
                            title={<Text keyboard> Additional App Data </Text>}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                            bordered={true}
                            loading={load}
                        >
                            {load ? (
                                <div>
                                    <Spin size="small" />
                                </div>
                            ) : (
                                <>
                                    <Table
                                        rowKey="appAddn_id"
                                        size="small"
                                        bordered
                                        pagination={false}
                                        dataSource={compAddnData}
                                        columns={[
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Release </div>;
                                                },
                                                dataIndex: 'release',
                                                key: 'release',
                                                fixed: 'left',
                                                width: '10%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Priority </div>;
                                                },
                                                dataIndex: 'priority',
                                                key: 'priority',
                                                fixed: 'left',
                                                width: '10%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Instance Support </div>;
                                                },
                                                dataIndex: 'ins_support',
                                                key: 'ins_support',
                                                fixed: 'left',
                                                width: '15%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Synthetic Support </div>;
                                                },
                                                dataIndex: 'syn_support',
                                                key: 'syn_support',
                                                fixed: 'left',
                                                width: '15%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>dlp </div>;
                                                },
                                                dataIndex: 'dlp',
                                                key: 'dlp',
                                                fixed: 'left',
                                                width: '5%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>tss </div>;
                                                },
                                                dataIndex: 'tss',
                                                key: 'tss',
                                                fixed: 'left',
                                                width: '5%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                        ]}
                                        loading={load}
                                    />
                                </>
                            )}
                        </Card>
                    ) : null}
                </>
            ) : (
                <div className={styles.spinner}>{<Spin size="small" />}</div>
            )}
        </>
    );
};
